import React from 'react'
import { AiFillEdit } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { DataGrid, GridToolbar, GridActionsCellItem } from '@mui/x-data-grid';
import useArge from '../../hooks/useArge';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material'


const DokumHatti_DataTable = ({ dokumHattiData, setInfo, info, delHandleOpen, handleOpen, filterModel, setFilterModel ,dokumHatti, setdokumHatti}) => {


  const dataGrid_Columns = [
    // {
    //     field: "id",
    //     headerName: "ID",
    //     minWidth: 150,
    //     headerAlign: "center",
    //     align: "center",
    //     flex: 1,
    // },
    {
      field: "actions",
      headerName: "#",
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: ({ id,
        row: {
          is_merkezi,
          aciklama,
          urun_kodu,
          kurutmaSicakligi,
          camurSicakligi,
          yogunluk,
          t1,
          t2,
          t1t2,
          ucDakika,
          besDakika,
          onDakika,
          agirlik,
          taban,
          ab,
          cd,
          cidarKalinlik,
          catlak,
          rotus,
          yuzeyKontrol,
          uygunsuzlukTipi,
          vardiyaSorumlusu,

        } }) => {
        return [
          <GridActionsCellItem
            key={"edit"}
            icon={<AiFillEdit size={25} style={{ color: '#0802A3' }} cursor='pointer' />}
            label="Edit"
            onClick={() => {
              handleOpen()
              setInfo({
                id,
                type: 'DokumHatti',
                is_merkezi,
                aciklama,
                urun_kodu,
                kurutmaSicakligi,
                camurSicakligi,
                yogunluk,
                t1,
                t2,
                t1t2,
                ucDakika,
                besDakika,
                onDakika,
                agirlik,
                taban,
                ab,
                cd,
                cidarKalinlik,
                catlak,
                rotus,
                yuzeyKontrol,
                uygunsuzlukTipi,
                vardiyaSorumlusu,
              })
            }}

          />,
          <GridActionsCellItem
            key={"delete"}
            icon={<MdDelete size={25} style={{ color: '#D80032' }} cursor='pointer' />}
            label="Delete"
            onClick={() => {
              delHandleOpen()
              setInfo({ id, type: 'DokumHatti' })
            }}

          />,
        ]
      },
    },
    {
      field: "date",
      headerName: "Tarih",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "time",
      headerName: "Saat",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "vardiya",
      headerName: "Vardiya",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "kontroleden_kisi",
      headerName: "Kontrol Yapan",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "is_merkezi",
      headerName: "İş Merkezi",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "urun_kodu",
      headerName: "Ürün Kodu",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "kurutmaSicakligi",
      headerName: "Kurutma Sıcaklığı",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "camurSicakligi",
      headerName: "Çamur Sıcaklığı",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "yogunluk",
      headerName: "Yoğunluk",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "t1",
      headerName: "T1",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "t2",
      headerName: "T2",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "t1t2",
      headerName: "T1T2",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "ucDakika",
      headerName: "ucDakika",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "besDakika",
      headerName: "besDakika",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "onDakika",
      headerName: "onDakika",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "agirlik",
      headerName: "Ağırlık",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "taban",
      headerName: "Taban",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "ab",
      headerName: "AB",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "cd",
      headerName: "CD",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "cidarKalinlik",
      headerName: "Cidar Kalinlik",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "catlak",
      headerName: "Çatlak",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "rotus",
      headerName: "Rötüş",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },

    {
      field: "yuzeyKontrol",
      headerName: "Yüzey Kontrol",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "kurutmaSicakligi",
      headerName: "Kurutma Sicakligi",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "camurSicakligi",
      headerName: "Camur Sicakligi",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "uygunsuzlukTipi",
      headerName: "Uygunsuzluk Tipi",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "vardiyaSorumlusu",
      headerName: "Vardiya Sorumlusu",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },


  ];


  useEffect(() => {
    const dizi = Object.keys(dokumHattiData).map(key => { return { id: key, ...dokumHattiData[key] } })
    dizi.sort((a, b) => {
      const convertDateTime = (date, time) => {
        if (!date || !time) {
          // Eğer date veya time undefined veya boş string ise, geçerli bir tarih döndürmeyebilir.
          // Bu durumu ele almak için bir alternatif dönüş değeri sağlayabilirsiniz.
          // Örneğin, çok geçmiş veya gelecek bir tarih olabilir.
          // Burada örnek olarak Unix Epoch başlangıcını kullanıyoruz.
          return new Date(0); // 1 Ocak 1970
        }
        const [day, month, year] = date.split('-').map(num => num.padStart(2, '0'));
        const [hours, minutes] = time.split(':').map(num => num.padStart(2, '0'));
        return new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
      };

      const dateTimeA = convertDateTime(a.date, a.time);
      const dateTimeB = convertDateTime(b.date, b.time);

      return dateTimeB - dateTimeA;
    })
    setdokumHatti(dizi)
  }, [dokumHattiData])


  const handleFilterChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
  };


  
  return (


    <DataGrid
      columns={dataGrid_Columns}
      rows={dokumHatti}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
      pageSizeOptions={[10, 25, 50, 75, 100]}
      slots={{ toolbar: GridToolbar }}
      disableRowSelectionOnClick
      sx={{
        boxShadow: 4,
      }}
      // grid üzerinde filter işlemi yapılırsa filter model özelliği ile yakalanır
      filterModel={filterModel}
      onFilterModelChange={handleFilterChange}
    />


  )
}

export default DokumHatti_DataTable